"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.lipoproteinDisturbancesTypeMessages = exports.diabetesComplicationMessages = exports.diabetesTypeMessages = exports.metabolicDiseaseTypeMessages = exports.hasDiseaseMessages = exports.LipoproteinDisturbancesType = exports.DiabetesComplication = exports.DiabetesType = exports.MetabolicDiseaseType = exports.HasDisease = void 0;
const schema_1 = require("../../../../schema");
var HasDisease;
(function (HasDisease) {
    HasDisease["HAS_METABOLIC_DISEASE"] = "has_metabolic_disease";
    HasDisease["NO_UNKNOWN_METABOLIC_DISEASE"] = "no_unknown_metabolic_disease";
})(HasDisease || (exports.HasDisease = HasDisease = {}));
var MetabolicDiseaseType;
(function (MetabolicDiseaseType) {
    MetabolicDiseaseType["DIABETES"] = "diabetes";
    MetabolicDiseaseType["LIPOPROTEIN_DISTURBANCES"] = "lipoprotein_disturbances";
    MetabolicDiseaseType["PURINE_AND_PIRIMIDINE_METABOLIC_DISTURBANCES"] = "purine_and_pirimidine_metabolic_disturbances";
    MetabolicDiseaseType["AMINO_ACID_METABOLIC_DISTURBANCES"] = "amino_acid_metabolic_disturbances";
    MetabolicDiseaseType["LACTOSE_INTOLERANCE"] = "lactose_intolerance";
    MetabolicDiseaseType["SPHYNGOLIPID_AND_GLUCOSAMINOGLYCANE"] = "sphyngolipid_and_glucosaminoglycane";
    MetabolicDiseaseType["PORPHYRIN_AND_BILIRUBIN_METABOLIC_DISTURBANCES"] = "porphyrin_and_bilirubin_metabolic_disturbances";
    MetabolicDiseaseType["HYPOTHYREOSIS"] = "hypothyreosis";
    MetabolicDiseaseType["HYPERTHYREOSIS"] = "hyperthyreosis";
    MetabolicDiseaseType["ADRENAL_DISFUNCTION"] = "adrenal_disfunction";
    MetabolicDiseaseType["PITUITARY_MALFUNCTION"] = "pituitary_malfunction";
    MetabolicDiseaseType["THYMUS_DISORDER"] = "thymus_disorder";
    MetabolicDiseaseType["MISCELLANEOUS"] = "miscellaneous";
})(MetabolicDiseaseType || (exports.MetabolicDiseaseType = MetabolicDiseaseType = {}));
var DiabetesType;
(function (DiabetesType) {
    DiabetesType["T1_DM"] = "T1DM";
    DiabetesType["T2_DM"] = "T2DM";
    DiabetesType["GESTATIONAL_DM"] = "gestational_DM";
    DiabetesType["PANCREATIC_DM"] = "pancreatic_DM";
    DiabetesType["LADA"] = "LADA";
    DiabetesType["MODY"] = "MODY";
    DiabetesType["NODAT"] = "NODAT";
    DiabetesType["OTHER"] = "other";
})(DiabetesType || (exports.DiabetesType = DiabetesType = {}));
var DiabetesComplication;
(function (DiabetesComplication) {
    DiabetesComplication["MICROVASCULAR_CONSEQUENCE"] = "microvascular_consequence";
    DiabetesComplication["MACROVASCULAR_CONSEQUENCE"] = "macrovascular_consequence";
    DiabetesComplication["POLYNEUROPATHY"] = "polyneuropathy";
})(DiabetesComplication || (exports.DiabetesComplication = DiabetesComplication = {}));
var LipoproteinDisturbancesType;
(function (LipoproteinDisturbancesType) {
    LipoproteinDisturbancesType["HYPERCHOLESTERINAEMIA"] = "Hypercholesterinaemia";
    LipoproteinDisturbancesType["HYPERTRIGLICERIDAEMIA"] = "Hypertrigliceridaemia";
    LipoproteinDisturbancesType["MIXED_HYPERLIPIDAEMIA"] = "mixed hyperlipidaemia";
    LipoproteinDisturbancesType["OTHER"] = "other";
})(LipoproteinDisturbancesType || (exports.LipoproteinDisturbancesType = LipoproteinDisturbancesType = {}));
exports.hasDiseaseMessages = {
    [HasDisease.HAS_METABOLIC_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.hasDisease.HAS_METABOLIC_DISEASE",
        defaultMessage: "Diagnosztizált anyagcsere betegség"
    },
    [HasDisease.NO_UNKNOWN_METABOLIC_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.hasDisease.NO_UNKNOWN_METABOLIC_DISEASE",
        defaultMessage: "Nincs vagy nem ismert"
    }
};
exports.metabolicDiseaseTypeMessages = {
    [MetabolicDiseaseType.DIABETES]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.DIABETES",
        defaultMessage: "Diabetes"
    },
    [MetabolicDiseaseType.LIPOPROTEIN_DISTURBANCES]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.LIPOPROTEIN_DISTURBANCES",
        defaultMessage: "Lipoprotein anyagcsere zavar"
    },
    [MetabolicDiseaseType.PURINE_AND_PIRIMIDINE_METABOLIC_DISTURBANCES]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.PURINE_AND_PIRIMIDINE_METABOLIC_DISTURBANCES",
        defaultMessage: "Purin és pirimidin anyagcsere zavara"
    },
    [MetabolicDiseaseType.AMINO_ACID_METABOLIC_DISTURBANCES]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.AMINO_ACID_METABOLIC_DISTURBANCES",
        defaultMessage: "Aminósav anyagcsere zavar"
    },
    [MetabolicDiseaseType.LACTOSE_INTOLERANCE]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.LACTOSE_INTOLERANCE",
        defaultMessage: "Laktóz intolerancia"
    },
    [MetabolicDiseaseType.SPHYNGOLIPID_AND_GLUCOSAMINOGLYCANE]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.SPHYNGOLIPID_AND_GLUCOSAMINOGLYCANE",
        defaultMessage: "Sphyngolipid és glucoseaminoglicane rendellenesség"
    },
    [MetabolicDiseaseType.PORPHYRIN_AND_BILIRUBIN_METABOLIC_DISTURBANCES]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.PORPHYRIN_AND_BILIRUBIN_METABOLIC_DISTURBANCES",
        defaultMessage: "Porphyrin és bilirubin anyagcsere zavar"
    },
    [MetabolicDiseaseType.HYPOTHYREOSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.HYPOTHYREOSIS",
        defaultMessage: "Pajzsmirigy alulműködés"
    },
    [MetabolicDiseaseType.HYPERTHYREOSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.HYPERTHYREOSIS",
        defaultMessage: "Pajzsmirigy túlműködés"
    },
    [MetabolicDiseaseType.ADRENAL_DISFUNCTION]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.ADRENAL_DISFUNCTION",
        defaultMessage: "Mellékvese elégtelenség"
    },
    [MetabolicDiseaseType.PITUITARY_MALFUNCTION]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.PITUITARY_MALFUNCTION",
        defaultMessage: "Hipofízis elégtelenség"
    },
    [MetabolicDiseaseType.THYMUS_DISORDER]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.THYMUS_DISORDER",
        defaultMessage: "Thymus rendellenesség"
    },
    [MetabolicDiseaseType.MISCELLANEOUS]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.metabolicDiseaseType.MISCELLANEOUS",
        defaultMessage: "Egyéb"
    }
};
exports.diabetesTypeMessages = {
    [DiabetesType.T1_DM]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.diabetesType.T1_DM",
        defaultMessage: "T1DM"
    },
    [DiabetesType.T2_DM]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.diabetesType.T2_DM",
        defaultMessage: "T2DM"
    },
    [DiabetesType.GESTATIONAL_DM]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.diabetesType.GESTATIONAL_DM",
        defaultMessage: "Gesztációs DM"
    },
    [DiabetesType.PANCREATIC_DM]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.diabetesType.PANCREATIC_DM",
        defaultMessage: "Pancreatogén DM"
    },
    [DiabetesType.LADA]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.diabetesType.LADA",
        defaultMessage: "LADA"
    },
    [DiabetesType.MODY]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.diabetesType.MODY",
        defaultMessage: "MODY"
    },
    [DiabetesType.NODAT]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.diabetesType.NODAT",
        defaultMessage: "NODAT"
    },
    [DiabetesType.OTHER]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.diabetesType.OTHER",
        defaultMessage: "Egyéb"
    }
};
exports.diabetesComplicationMessages = {
    [DiabetesComplication.MICROVASCULAR_CONSEQUENCE]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.diabetesComplication.MICROVASCULAR_CONSEQUENCE",
        defaultMessage: "Microvaszkuláris szövődmény"
    },
    [DiabetesComplication.MACROVASCULAR_CONSEQUENCE]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.diabetesComplication.MACROVASCULAR_CONSEQUENCE",
        defaultMessage: "Makrovaszkuláris szövődmény"
    },
    [DiabetesComplication.POLYNEUROPATHY]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.diabetesComplication.POLYNEUROPATHY",
        defaultMessage: "Polyneuropthia"
    }
};
exports.lipoproteinDisturbancesTypeMessages = {
    [LipoproteinDisturbancesType.HYPERCHOLESTERINAEMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.lipoproteinDisturbancesType.HYPERCHOLESTERINAEMIA",
        defaultMessage: "Hypercholesterinaemia"
    },
    [LipoproteinDisturbancesType.HYPERTRIGLICERIDAEMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.lipoproteinDisturbancesType.HYPERTRIGLICERIDAEMIA",
        defaultMessage: "Hypertrigliceridaemia"
    },
    [LipoproteinDisturbancesType.MIXED_HYPERLIPIDAEMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.lipoproteinDisturbancesType.MIXED_HYPERLIPIDAEMIA",
        defaultMessage: "Kevert hyperlipidaemia"
    },
    [LipoproteinDisturbancesType.OTHER]: {
        id: "ktx.transplantationScreening.medicalHistory.metabolicDisease.lipoproteinDisturbancesType.OTHER",
        defaultMessage: "Egyéb"
    }
};
const hasDisease = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasDisease.HAS_METABOLIC_DISEASE).interpretation({
        vocab: "ktx",
        code: "has_metabolic_disease"
    }),
    schema_1.Schema.singleChoiceItem(HasDisease.NO_UNKNOWN_METABOLIC_DISEASE)
        .interpretation({ vocab: "ktx", code: "no_unknown_metabolic_disease" })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" })
]).interpretation({ vocab: "ktx", code: "has_metabolic_disease_choice" });
const metabolicDiseaseType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.DIABETES)
        .interpretation({ vocab: "ktx", code: "diabetes" })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.LIPOPROTEIN_DISTURBANCES)
        .interpretation({ vocab: "ktx", code: "lipoprotein_disturbances" })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.PURINE_AND_PIRIMIDINE_METABOLIC_DISTURBANCES)
        .interpretation({
        vocab: "ktx",
        code: "purine_and_pirimidine_metabolic_disturbances"
    })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.AMINO_ACID_METABOLIC_DISTURBANCES)
        .interpretation({
        vocab: "ktx",
        code: "amino_acid_metabolic_disturbances"
    })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.LACTOSE_INTOLERANCE)
        .interpretation({ vocab: "ktx", code: "lactose_intolerance" })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.SPHYNGOLIPID_AND_GLUCOSAMINOGLYCANE)
        .interpretation({
        vocab: "ktx",
        code: "sphyngolipid_and_glucosaminoglycane"
    })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.PORPHYRIN_AND_BILIRUBIN_METABOLIC_DISTURBANCES)
        .interpretation({
        vocab: "ktx",
        code: "porphyrin_and_bilirubin_metabolic_disturbances"
    })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.HYPOTHYREOSIS)
        .interpretation({ vocab: "ktx", code: "hypothyreosis" })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.HYPERTHYREOSIS)
        .interpretation({ vocab: "ktx", code: "hyperthyreosis" })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.ADRENAL_DISFUNCTION)
        .interpretation({ vocab: "ktx", code: "adrenal_disfunction" })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.PITUITARY_MALFUNCTION)
        .interpretation({ vocab: "ktx", code: "pituitary_malfunction" })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.THYMUS_DISORDER)
        .interpretation({ vocab: "ktx", code: "thymus_disorder" })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" }),
    schema_1.Schema.singleChoiceItem(MetabolicDiseaseType.MISCELLANEOUS)
        .interpretation({ vocab: "ktx", code: "miscellaneous" })
        .tag({ vocab: "ktx", code: "metabolic_disease_type" })
])
    .transferInterpretationsAndTagsToParent()
    .expiration(31536000);
const diabetesType = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../metabolicDiseaseType} === "diabetes"`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DiabetesType.T1_DM),
    schema_1.Schema.singleChoiceItem(DiabetesType.T2_DM),
    schema_1.Schema.singleChoiceItem(DiabetesType.GESTATIONAL_DM),
    schema_1.Schema.singleChoiceItem(DiabetesType.PANCREATIC_DM),
    schema_1.Schema.singleChoiceItem(DiabetesType.LADA),
    schema_1.Schema.singleChoiceItem(DiabetesType.MODY),
    schema_1.Schema.singleChoiceItem(DiabetesType.NODAT),
    schema_1.Schema.singleChoiceItem(DiabetesType.OTHER)
]));
const diabetesComplication = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../metabolicDiseaseType} === "diabetes"`), schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(DiabetesComplication.MICROVASCULAR_CONSEQUENCE).interpretation({ vocab: "ktx", code: "microvascular_consequence" }),
    schema_1.Schema.multiChoiceItem(DiabetesComplication.MACROVASCULAR_CONSEQUENCE).interpretation({ vocab: "ktx", code: "macrovascular_consequence" }),
    schema_1.Schema.multiChoiceItem(DiabetesComplication.POLYNEUROPATHY).interpretation({ vocab: "ktx", code: "polyneuropathy" })
]).optional());
const lipoproteinDisturbancesType = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../metabolicDiseaseType} === "lipoprotein_disturbances"`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(LipoproteinDisturbancesType.HYPERCHOLESTERINAEMIA),
    schema_1.Schema.singleChoiceItem(LipoproteinDisturbancesType.HYPERTRIGLICERIDAEMIA),
    schema_1.Schema.singleChoiceItem(LipoproteinDisturbancesType.MIXED_HYPERLIPIDAEMIA),
    schema_1.Schema.singleChoiceItem(LipoproteinDisturbancesType.OTHER)
]));
const comment = schema_1.Schema.string().optional().maxLength(10000);
const diseases = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasDisease} === "has_metabolic_disease"`), schema_1.Schema.array().default([]).minItems(1).items(schema_1.Schema.object().default({}).sealed(true).properties({
    metabolicDiseaseType,
    diabetesType,
    diabetesComplication,
    lipoproteinDisturbancesType,
    comment
})));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasDisease, diseases });
